export default "__VITE_PUBLIC_ASSET__5319c28a__"